// AUTO-GENERATED by shared/generators/config_enums_generator.py — do not edit.
// LandedCostAllocationMethod — source: shared/config/landed_cost_allocation_methods.config.json

export const LANDED_COST_ALLOCATION_METHOD_VALUES = ["BY_VALUE", "BY_QUANTITY", "BY_WEIGHT", "BY_VOLUME", "MANUAL"] as const;
export type LandedCostAllocationMethod = (typeof LANDED_COST_ALLOCATION_METHOD_VALUES)[number];

